"use strict";

$(document).ready(function () {

  var navBar = $("#navbar-lps a");
  var loaderContainer = $("#loader_container");
  var cardListContent = $("#lp-content");
  var loader = $('.jc-loader');
  var loaderMoreCars = $('#loader-more-cars');
  var currentPage = function currentPage() {
    var page_array = window.location.href.split("/");
    return page_array.filter(Boolean)[4];
  };

  navBar.on('click', function (event) {
    event.preventDefault();
    loaderContainer.removeClass('d-none');

    var item = $(this).attr('data-nav-item');
    var taxonomy = $(this).attr('data-nav-taxonomy');

    $.ajax({
      type: 'GET',
      dataType: 'html',
      url: ajaxHandler.url,
      cache: false,
      data: {
        action: 'jc_ajax_get_lp_catalog',
        item: item,
        taxonomy: taxonomy
      },
      beforeSend: function beforeSend() {
        loaderContainer.css('display', 'flex').show();
        cardListContent.hide();
        loader.addClass('mb-5');
        loaderMoreCars.addClass('d-none');
        loader.removeClass('d-none');
        loader.addClass('d-block');
      },
      complete: function complete() {
        loaderContainer.css('display', 'none').hide();
        cardListContent.show();
        loaderMoreCars.removeClass('d-none');
        loader.removeClass('d-block');
        loader.addClass('d-none');
      },
      success: function success(response) {
        window.history.pushState("object or string", "" + taxonomy, "/guia-de-compras/carros-0km/" + currentPage() + "/" + item + "/");
        cardListContent.html(response);
      }
    });
  });
});